<template>
  <div id="BaseLoadingPage">
    <BaseHeader
      :theme="theme"
      :should-show-nav-icons="false"
      :should-show-search-controls="false"
      :should-show-main-menu="false"
    />
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="loader" />
          <h5 class="text-center">
            Loading...
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import BaseHeader from "@/components/Header/BaseHeader"

  export default {
    components: {
      BaseHeader
    },
    props: {
      theme: {
        type: String,
        default: "Default"
      }
    }
  }

</script>
